import { jsx as _jsx } from "react/jsx-runtime";
import { removeSecureStorageToken } from "core/apollo/SecureStoragePluginFunctions";
import { BankingUserLogoutComponent } from "generated/generated-models";
export const Logout = (props) => {
    const { onLogout } = props;
    return (_jsx(BankingUserLogoutComponent, { onCompleted: async () => {
            if (onLogout) {
                onLogout();
            }
            await removeSecureStorageToken();
        }, onError: async () => {
            if (onLogout) {
                onLogout();
            }
            await removeSecureStorageToken();
        }, children: (logoutMuation, { called }) => {
            if (!called) {
                logoutMuation().catch(() => {
                    if (onLogout) {
                        onLogout();
                    }
                });
            }
            return (_jsx("div", { className: "content-wrapper flex-fill", children: _jsx("div", { className: "container sub-wrap", children: _jsx("p", { className: "logout-message", children: "Logged out! Please close your browser." }) }) }));
        } }));
};
